import axios from './axios';

export const getImplementation = () => axios.get('/implementation/v1/implementation/detail');

export const createImplementation = (data) => axios.post(`implementation/v1/process/create`, data);

export const getImplementationHandler = (tag) =>
    axios.get(`/implementation/v1/process/create/${tag}`);

export const getLicenses = () => axios.get(`/implementation/v1/license`);

export const getBillingPlatform = (id) =>
    axios.get(`/implementation/v1/billingplatformsplans?licenseEditionId=${id}`);

export const getTemplate = (id) => axios.get(`/implementation/v1/template?licenseEditionId=${id}`);

export const getPartners = () => axios.get('/implementation/v1/partner');

export const addLicenses = (data) => axios.put(`/implementation/v1/addlicenses`, data);

export const removeLicenses = (data) => axios.put(`/implementation/v1/removelicenses`, data);

export const getSubscriptionStatuses = () => axios.get('/implementation/v1/subscriptionStatuses');

export const setSubscriptionStatus = (data) => axios.put('/implementation/v1/subscription', data); // data = {"status":2}

export const setImplementationUrl = (data) =>
    axios.post('/implementation/v1/implementation/implementationUrl', data); // data = {"url":"X"}

export const updateFreeTrial = (data) =>
    axios.post('/implementation/v1/implementation/updateFreeTrial', data);

export const getLicenseOptions = () => axios.get('/implementation/v1/adminPlatformFlow');

export const changeLicenseType = (data) => axios.post('/implementation/v1/adminPlatformFlow', data);

export const deleteImplementation = (data) => axios.delete('/implementation/v1', { data });

export const getResponsiblePartners = () => axios.get('/implementation/v1/partnerManager');

export const setResponsiblePartners = (data) =>
    axios.post('/implementation/v1/partnerManager', data);

export const setPartnerExtId = (data) => axios.post('/implementation/v1/implementationCode', data);

export const getImplementationSchema = () => axios.get('/implementation/v1/implementation/schema');

export const exportImplementations = (data) =>
    axios.post('/implementation/v1/implementation/export', data);
